export const ANALYTICS_EVENT_SOFTPHONE = {
  CONNECTION_STATUS_CHANGED: 'softphone_connection_status_changed',
  POOR_CONNECTION_TOOLTIP_SHOWN: 'softphone_poor_connection_tooltip_shown',
  CONNECTION_TOOLTIP_OPENED: 'softphone_connection_tooltip_opened',
  LOST_CONNECTION_DETECTED: 'softphone_lost_connection_detected',
  LOST_CONNECTION_AUDIO_STARTED: 'softphone_lost_connection_audio_started',
  LOST_CONNECTION_BANNER_SHOWN: 'softphone_lost_connection_banner_shown',
  CONNECTION_RESTORED: 'softphone_connection_restored',
  CALL_ENDED_DURING_CONNECTION_ISSUE: 'softphone_call_ended_during_connection_issue',
  SHORTCUT_TOOLTIP_VIEWED: 'shortcut_tooltip_viewed',
  SHORTCUT_MUTE_TRIGGERED: 'softphone_shortcut_mute_triggered',
  SHORTCUT_HOLD_TRIGGERED: 'softphone_shortcut_hold_triggered',
  SHORTCUT_ACCEPT_TRIGGERED: 'softphone_shortcut_accept_triggered',
  SHORTCUT_DECLINE_TRIGGERED: 'softphone_shortcut_decline_triggered',
  SHORTCUT_END_TRIGGERED: 'softphone_shortcut_end_triggered',
  SHORTCUT_KEYPAD_TRIGGERED: 'softphone_shortcut_keypad_triggered',
  SHORTCUT_VIDEO_TRIGGERED: 'softphone_shortcut_video_triggered',
  SHORTCUT_TRANSFER_TRIGGERED: 'softphone_shortcut_transfer_triggered',
  SHORTCUT_MERGE_TRIGGERED: 'softphone_shortcut_merge_triggered',

  /**
   * A screen reader is out of the page's reach: nothing reports what was
   * spoken. These measure the moment the app did the thing that makes an
   * announcement possible — text landing in a live region, or focus reaching a
   * control — which is the closest observable proxy. Read them as "the app
   * offered this", never as "the user heard this".
   *
   * The announcement events fire when the text actually reaches the region,
   * after the debounce, so a burst collapsed into one write counts once.
   */
  SR_TOGGLE_STATE_ANNOUNCED: 'softphone_sr_toggle_state_announced',
  SR_CALL_STATE_ANNOUNCED: 'softphone_sr_call_state_announced',
  SR_DISABLED_CONTROL_ANNOUNCED: 'softphone_sr_disabled_control_announced',
  SR_VIEW_ENTRY_FOCUS: 'softphone_sr_view_entry_focus',
  SR_DURATION_ANNOUNCED: 'softphone_sr_duration_announced',
} as const;
